<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Split / Separate ID
          </div>
        </template>
      </es-header>
    </div>
    <es-loader
      v-if="loading"
      style="margin: 3rem"
    />
    <div v-else>
      <div class="no-border-top">
        <div class="no-bottom-border">
          <es-form>
            <template #es-form>
              <div class="row removeUnderline">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label" id="stateIdLabel">
                      ID to Split
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input
                          type="text"
                          class="input"
                          v-model="stateId"
                          :class="{'is-danger' : hasErrorIdToSplit}"
                          aria-labelledby="stateIdLabel"
                          @keypress="isWholeNumbers($event)"
                          @input="validateField"
                          maxlength="15"
                        >
                      </div>
                      <span v-if="hasErrorIdToSplit" class="help is-danger">
                        {{ msgIdToSplit }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
        </div>
      </div>
      <div
        class="is-flex flex-justify--end flex-align--center"
        style="margin-right: 5.15rem; padding-bottom: 2rem"
      >
        <button
          class="button button-link has-underline"
          @click="reset"
          style="margin-right: 1rem"
        >
          Reset
        </button>
        <button
          class="button is-primary"
          @click="submit"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import NotificationManager from '@/mixins/NotificationManager';

export default {
  mixins: [
    NotificationManager,
  ],
  components: {
    EsForm,
    EsHeader,
    EsLoader,
  },
  data() {
    return this.initialData();
  },
  methods: {
    initialData() {
      return {
        formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
        hasErrorIdToSplit: false,
        loading: false,
        msgIdToSplit: null,
        stateId: null,
      };
    },
    isWholeNumbers(evt) {
      // Listen to the key event when a keyboard key is pressed
      evt = (evt) || window.event; // eslint-disable-line
      // Store the ASCII value of the pressed key in 'charCode'
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      // Prevent user from entering any values except digits
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
        evt.preventDefault();
      }
    },
    reset() {
      this.stateId = null;
      this.hasErrorIdToSplit = false;
      this.msgIdToSplit = null;
      this.resetNotifications();
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    async submit() {
      this.validateField();
      if (this.hasErrorIdToSplit) {
        this.showError(this.formErrorMsg);
      } else {
        this.resetNotifications();
        this.loading = true;
        let tempId = this.stateId;
        tempId = tempId.trim();
        tempId = tempId.replace(/[-/ /]/g, '');
        try {
          const response = await axios.get(`idmanager/validate?id=${tempId}`);
          if (response.status === 200) {
            this.$router.push({
              name: 'PISplitIdDetails',
              query: { stateId: tempId },
            });
          }
        } catch (error) {
          this.showError(error.response.data.message);
          this.loading = false;
        }
      }
    },
    validateField() {
      if (!this.stateId) {
        this.hasErrorIdToSplit = true;
        this.msgIdToSplit = 'ID to Split is required.';
      } else {
        this.hasErrorIdToSplit = false;
        this.msgIdToSplit = null;
        this.resetNotifications();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
